import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const StyledBackButton = styled.button`
  background: none;
  border: 2px solid black;
  color: rgb(33, 34, 33);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1rem;
  padding: 0.7rem;
  border-radius: 5px;
  transition: all 0.3s ease;
  width: 100%;
  margin-top: 1rem;

  &:hover {
    background: rgba(0, 123, 255, 0.1);
    transform: translateX(-3px);
  }

  svg {
    font-size: 1.2rem;
  }
`;

const BackButton = ({ onClick, children = 'Back to Home' }) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/');
    }
  };

  return (
    <StyledBackButton onClick={handleClick}>
      <FaArrowLeft />
      {children}
    </StyledBackButton>
  );
};

export default BackButton; 